// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/secret.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateSecretRequest, CreateSecretResponse, DeleteSecretRequest, DeleteSecretResponse, GetSecretValueRequest, GetSecretValueResponse, ListSecretsRequest, ListSecretsResponse, UpdateSecretValueRequest, UpdateSecretValueResponse } from "./secret_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.SecretService
 */
export const SecretService = {
  typeName: "gitpod.v1.SecretService",
  methods: {
    /**
     * Creates a new secret for a project.
     *
     * Use this method to:
     * - Store sensitive configuration values
     * - Set up environment variables
     * - Configure registry authentication
     * - Add file-based secrets
     *
     * ### Examples
     *
     * - Create environment variable:
     *
     *   Creates a secret that will be available as an environment variable.
     *
     *   ```yaml
     *   name: "DATABASE_URL"
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   value: "postgresql://user:pass@localhost:5432/db"
     *   environmentVariable: true
     *   ```
     *
     * - Create file secret:
     *
     *   Creates a secret that will be mounted as a file.
     *
     *   ```yaml
     *   name: "SSH_KEY"
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   value: "-----BEGIN RSA PRIVATE KEY-----\n..."
     *   filePath: "/home/gitpod/.ssh/id_rsa"
     *   ```
     *
     * - Create registry auth:
     *
     *   Creates credentials for private container registry.
     *
     *   ```yaml
     *   name: "DOCKER_AUTH"
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   value: "username:password"
     *   containerRegistryBasicAuthHost: "https://registry.example.com"
     *   ```
     *
     * @generated from rpc gitpod.v1.SecretService.CreateSecret
     */
    createSecret: {
      name: "CreateSecret",
      I: CreateSecretRequest,
      O: CreateSecretResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the value of an existing secret.
     *
     * Use this method to:
     * - Rotate secret values
     * - Update credentials
     *
     * ### Examples
     *
     * - Update secret value:
     *
     *   Changes the value of an existing secret.
     *
     *   ```yaml
     *   secretId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   value: "new-secret-value"
     *   ```
     *
     * @generated from rpc gitpod.v1.SecretService.UpdateSecretValue
     */
    updateSecretValue: {
      name: "UpdateSecretValue",
      I: UpdateSecretValueRequest,
      O: UpdateSecretValueResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SecretService.ListSecrets
     */
    listSecrets: {
      name: "ListSecrets",
      I: ListSecretsRequest,
      O: ListSecretsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Deletes a secret permanently.
     *
     * Use this method to:
     * - Remove unused secrets
     * - Clean up old credentials
     *
     * ### Examples
     *
     * - Delete secret:
     *
     *   Permanently removes a secret.
     *
     *   ```yaml
     *   secretId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.SecretService.DeleteSecret
     */
    deleteSecret: {
      name: "DeleteSecret",
      I: DeleteSecretRequest,
      O: DeleteSecretResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the value of a secret. Only available to environments that are authorized to access the secret.
     *
     * Use this method to:
     * - Retrieve secret values
     * - Access credentials
     *
     * ### Examples
     *
     * - Get secret value:
     *
     *   Retrieves the value of a specific secret.
     *
     *   ```yaml
     *   secretId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.SecretService.GetSecretValue
     */
    getSecretValue: {
      name: "GetSecretValue",
      I: GetSecretValueRequest,
      O: GetSecretValueResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

